import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './stores/actionsList';
// import { Route, Switch } from "react-router-dom";

import i18n from 'i18next';
import { siteConfig } from './variables/config'
import { changeUrlWithLng, getObject, getToken, getUserInfo, pathMaker } from './utils/useful'

// import routes from './variables/routes'
// import Header from './components/Header'
// import Footer from './components/Footer';
// import TabBar from './components/TabBar';
import NotifManager from './components/NotifManager';
import { initSocket, socket } from './utils/socket.services';

// import { io } from "socket.io-client";
// import ProtectedRoute from './components/ProtectedRoute';
// import { carbonPages, carbonSections } from './variables/carbonPages';
// import { energyPages, energySections } from './variables/energyPages';
// import { adminPages, adminSections } from './variables/adminPages';
import HttpServices from './utils/Http.services';
import store from './stores/storeConfig';
// import { settingsPages, settingsSections } from './variables/settingsPages';
import StagesManager from './components/StagesManager';
// import Home from './pages/Home';
import ProtectedApp from './ProtectedApp';
import LoginWithUsername from './pages/LoginWithUsername';

// import Modal from './components/Modal'
// import './App.css';


class App extends React.Component {

    state = {
        lngRoute: '',
        showPage: true,
        frames: 'dashboard',
        frameObject: {},

    }



    // socket = null
    componentDidMount() {
        this.initConfig()
        // initSocket()
        setTimeout(() => {
            this.initCheckLocation()
            this.checkUser()
        }, 100);

    }



    componentDidUpdate(e) {


        if (e.history.action === "PUSH" && this.state.prevLoc !== e.history.location) {
            window.scrollTo(0, 0)
            this.props.actions.changeSetting('lastLocation', this.state.prevLoc)
            this.setState({ prevLoc: e.history.location })
            this.initCheckLocation()

        }

        if (this.props.user.loggedin !== e.user.loggedin && this.props.user.loggedin) {
            this.checkUser()
            this.initCheckLocation()

        }
        if (this.props.location.pathname != e.location.pathname) {
            this.initCheckLocation()
        }


    }

    componentWillUnmount() {
        window.removeEventListener('popstate', this.initCheckLocation);
        window.removeEventListener('urlchange', this.initCheckLocation);
        window.removeEventListener('resize', this.setSize)

    }



    initConfig() {
        // this.props.actions.changeSetting('hideTabBar', false)

        // SET LANGNGUAGE
        let parent = this
        i18n.on('languageChanged', (lng) => {
            // this.setState({ showPage: false }, () => {


            if (siteConfig.forceUrl) {
                changeUrlWithLng(lng)
            }
            this.props.actions.changeLanguage('language', lng)
            // window.location.reload();

            //     this.setState({ showPage: true })
            // })

        })
        this.setSize()
        this.patchHistoryMethods();

        window.addEventListener('popstate', this.initCheckLocation);
        window.addEventListener('urlchange', this.initCheckLocation);


        window.addEventListener('resize', this.setSize)

    }


    patchHistoryMethods = () => {
        ['pushState', 'replaceState'].forEach(type => {
            const original = window.history[type];
            window.history[type] = function (...args) {
                const result = original.apply(this, args);
                window.dispatchEvent(new Event('urlchange'));
                return result;
            };
        });
    };





    initCheckLocation = () => {

        // console.log("initCheckLocation")
        let windowPath = window.location.pathname.split('/')
        // console.log(windowPath)
        // console.log(windowPath)
        // windowPath = windowPath[windowPath.length - 1]
        // windowPath = windowPath[1]
        if (windowPath[1] == 'en') {
            store.dispatch(actions.initHeader(windowPath[2]))
        } else {

            store.dispatch(actions.initHeader(windowPath[1]))
        }

        let path = []
        for (let i = 0; i < windowPath.length; i++) {
            const element = windowPath[i];
            if (element != '') {
                path.push(element)
            }
        }

        // console.log("path", path)


        if (path[0] == 'login') {
            // console.log("OK")
            this.stageManager.changeStage('login')
        } else {
            if (this.props.user.loggedin) {
                this.stageManager.changeStage('protected')
            }
        }

        let params = {}
        let search = window.location.search;
        let rawparams = new URLSearchParams(search);

        for (const [key, value] of rawparams.entries()) {
            params[key] = value;
        }

        // console.log("window.location",window.location)
        // console.log("params",params)

        let windowData = { path: path,params }

        this.setState({ windowData })
        // console.log(this.props.location.pathname)


    }






    changeFormObject = (frame, frameValue) => {
        let frames = frame
        let frameObject = frameValue
        this.setState({ frames, frameObject })
    }


    // setData = (key, value, cb) => {
    //     // console.log('ridix key', key)
    //     // console.log('ridix', value)
    //     let frameObject = this.state.frameObject
    //     let frames = this.state.frames
    //     this.setState({ [key]: value }, () => {
    //         // console.log('this.state.frames', this.state.frames)

    //         switch (this.state.frames) {
    //             case 'document':
    //                 frameObject.child = Object.values(adminPages)
    //                 frameObject.section = Object.values(adminSections)
    //                 break;

    //             case 'energy':
    //                 frameObject.child = Object.values(energyPages)
    //                 frameObject.section = Object.values(energySections)
    //                 break;

    //             case 'carbon':
    //                 frameObject.child = Object.values(carbonPages)
    //                 frameObject.section = Object.values(carbonSections)
    //                 break;
    //             case 'settings':
    //                 frameObject.child = Object.values(settingsPages)
    //                 frameObject.section = Object.values(settingsSections)
    //                 break;
    //             default:
    //                 frameObject = {}
    //                 frames = 'dashboard';
    //         }
    //         this.setState({ frameObject }, () => {
    //             console.log('frameObject', frameObject)
    //         })
    //         if (cb) { cb() }
    //     })
    // }







    setSize = () => {
        let sizes = { isMobile: false, isTablet: false, isDesktop: false }
        let key = "isDesktop"
        let width = window.innerWidth
        if (width < 768 && width >= 576) {
            key = 'isTablet'
        }
        if (width < 576) {
            key = 'isMobile'
        }

        sizes[key] = true

        for (const [key, value] of Object.entries(sizes)) {
            this.props.actions.changeSetting(key, value)
        }

    }


    initServices = () => {
        // console.log('initServices')
        HttpServices.request('initConfig', {}, (fetchResult, fetchError) => {
            // console.log('fetchERRRRR', fetchError)
            if (fetchError) {
                return
            }
            // console.log('fetchResult', fetchResult)
            store.dispatch(actions.addInbox(fetchResult.inboxes))
        })
    }

    checkUser = (dontShowNotif) => {

        setTimeout(() => {
            // console.log("CHECK USER")
            // console.log(this.props.user.loggedin)
            if (this.props.user.loggedin) {
                if (getToken()) {
                    getUserInfo((data, err, status) => {

                        // console.log(data, err, status)

                        if (status === 401) {
                            console.log('status 401')
                            this.goToLogin()

                            return ``
                            this.props.actions.logoutUser()
                        }
                        if (status === 200 && data) {
                            // console.log("DFF")
                            // if (data.authorized) {
                            // console.log(data.user)
                            // console.log('authorized')
                            initSocket()
                            this.initServices()
                            this.props.actions.setUser(data.user, null, true)
                            this.initCheckLocation()

                            // this.goToStage('protected')

                            // } else {
                            //     this.props.actions.logoutUser()
                            // }
                        }

                        if (err) {
                            this.goToLogin()

                            if (!dontShowNotif) {
                                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.cantConnectToServer', description: '{{lang}}errors.checkYourInternetConnection' })
                            }
                            this.props.actions.setUser({}, null, true)
                            setTimeout(() => {
                                this.checkUser(true)
                            }, 10000);
                        }

                    })
                } else {
                    this.props.actions.logoutUser()
                    this.goToLogin()
                }
            } else {
                this.goToLogin()
            }
        }, 100);
    }


    goToStage = (stage) => {
        if (this.stageManager) {
            this.stageManager.changeStage(stage)
        }
    }

    goToLogin = () => {

        let path = "/login"
        setTimeout(() => {
            // console.log("goToLogin")
            window.history.pushState({}, '', path);
        }, 100);

    }


    setHeader = (data) => {
        // console.log(data)
        this.setState({ headerSettings: data })
    }


    render() {


        if (this.state.showPage) {
            return (
                <div className={"container-fluid default-theme m-0 p-0 w-100 " + (this.props.settings.isMobile ? 'mobile' : 'desktop')} >

                    <NotifManager>

                        <div className="d-flex w-100">

                            {/* {this.props.settings.showTabBar && (
                                // <></>
                                <TabBar />
                            )} */}


                            <div style={{ width: '100%', position: 'relative' }}>



                                <div className="w-100" style={{ minHeight: 'calc(100vh - 180px)', backgroundColor: '#fff' }} >

                                    <StagesManager ref={el => this.stageManager = el} fast={true}>

                                        <LoginWithUsername stage={1} stageName={'login'} setHeader={this.setHeader} location={this.props.location} windowData={this.state.windowData} history={this.props.history} />

                                        <ProtectedApp stage={1} stageName={'protected'} setHeader={this.setHeader} location={this.props.location} windowData={this.state.windowData} history={this.props.history} />


                                    </StagesManager>

                                </div>



                                {/* <div className="w-100" style={{ minHeight: '85vh', backgroundColor: '#fff' }} >
                                    <Switch>
                                        {routes.map((prop, index) => {
                                            if (prop.protected) {

                                                return (
                                                    <ProtectedRoute asghar={true} prop={prop} key={index} exact={prop.exact} path={(siteConfig.dontShowUrlForDefaultLng ? (i18n.language === siteConfig.defaultLng ? '' : '/' + i18n.language) : '/' + i18n.language) + prop.path} component={prop.component} setHeader={this.setHeader} />
                                                )
                                            } else {
                                                return (
                                                    <Route key={index}
                                                        exact={prop.exact}
                                                        path={(siteConfig.dontShowUrlForDefaultLng ? (i18n.language === siteConfig.defaultLng ? '' : '/' + i18n.language) : '/' + i18n.language) + prop.path}
                                                        component={prop.component}
                                                        setHeader={this.setHeader}
                                                    // render={(routeProps) => <prop.component {...routeProps} someProp="Hello!" />}
                                                    />
                                                )
                                            }
                                        })}
                                    </Switch>
                                </div> */}


                            </div>


                        </div>


                    </NotifManager>


                </div>
            )
        } else {
            return (<div></div>)
        }

    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user, resource: state.resource, notif: state.notif })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App);